import { UserAnnouncementEntitiesState } from './user-announcement-entities.state';

export const userAnnouncementEntitiesStateInitial: UserAnnouncementEntitiesState = {
  announcements: [],
  currentIndex: 0,
  imageUrls: {},
  isLoading: false,
  isLoaded: false,
  markedReadIds: [],
  enabled: true,
  hasUnread: false,
  error: null,
};
